/* eslint-disable */
import axios from "@/axios";
import store from "@/store";

export function getCampaigns({ params, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get("/campaigns", { headers, params, signal });
}

export function createCampaign({ payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.post("/campaigns", payload, { headers });
}

export function getCampaign({ campaignId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/campaigns/${campaignId}`, { headers, signal });
}

export function updateCampaign({ campaignId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.put(`/campaigns/${campaignId}`, payload, { headers });
}

export function deleteCampaign({ campaignId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.delete(`/campaigns/${campaignId}`, { headers });
}

export function getCampaignEvents({ campaignId, params, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/campaigns/${campaignId}/events`, { headers, params, signal });
}

export function createCampaignEvent({ campaignId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.post(`/campaigns/${campaignId}/events`, payload, { headers });
}

export function getCampaignEvent({ campaignId, eventId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/campaigns/${campaignId}/events/${eventId}`, { headers, signal });
}

export function updateCampaignEvent({ campaignId, eventId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.put(`/campaigns/${campaignId}/events/${eventId}`, payload, { headers });
}

export function getCampaignGroups({ campaignId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/campaigns/${campaignId}/groups`, { headers, signal });
}

export function createCampaignGroups({ campaignId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.post(`/campaigns/${campaignId}/groups`, payload, { headers });
}

export function getCampaignGroup({ campaignId, groupId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/campaigns/${campaignId}/groups/${groupId}`, { headers, signal });
}

export function updateCampaignGroup({ campaignId, groupId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.put(`/campaigns/${campaignId}/groups/${groupId}`, payload, { headers });
}

export function deleteCampaignGroup({ campaignId, groupId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.delete(`/campaigns/${campaignId}/groups/${groupId}`, { headers });
}

export function addSubscriberToCampaign({ campaignId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.put(`/campaigns/${campaignId}/subscribers`, payload, { headers });

}

export function getCampaignSubscriber({ campaignId, subscriberId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/campaigns/${campaignId}/subscribers/${subscriberId}`, { headers, signal });
}

export function updateCampaignSubscriber({ campaignId, subscriberId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.put(`/campaigns/${campaignId}/subscribers/${subscriberId}`, payload, { headers });
}

export function deleteCampaignSubscriber({ campaignId, subscriberId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.delete(`/campaigns/${campaignId}/subscribers/${subscriberId}`, { headers });
}